import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { BasemodelService } from '../basemodel.service';


@Component({
  selector: 'app-city',
  templateUrl: './city.component.html',
  styleUrls: ['./city.component.scss']
})
export class CityComponent {
  @Input() id1: any
  @Output() buttonWasClicked = new EventEmitter<any>();
  total: any;
  searchkey: any;
  constructor(private http: HttpClient, private router: ActivatedRoute, private spinner: NgxSpinnerService, public campuscctvserviceservice: CampuscctvserviceService, private base: BasemodelService) {
  }

  ngOnInit(): void {
    let id1: any;
    if (this.id1) {
      id1 = this.id1
    } else {
      id1 = this.router.snapshot.params['id']
    }

    const headers = { "Content-Type": "application/json", 'Access-Control-Allow-Origin': '/*' }
    this.spinner.show();
    this.http.get<any>((this.base.getcctv() + '/ses/cctv/cityWise?cityId=' + id1)).subscribe(Response => {
      this.total = Response;
      console.log(this.total);
      this.spinner.hide();
    },);
    this.campuscctvserviceservice.search.subscribe((val: any) => {
      this.searchkey = val;
    })
  }
  onbuttonClick(data: any) {
    this.buttonWasClicked.emit(data)
  }
}
